import { getEndpointServersList } from '../../../endpoint-servers/api/endpoint-servers-service';
export const actions = {
  /**
   * Checks if the existing dataset name already exist
   * @param { Object } ctx Vuex context
   * @param { String } name Name of dataset to be checked
   */
  async checkExistingDataset({ commit }, name) {
    try {
      commit('setNameError');
      const { exists } = await this.$axios.$get(`/api/dataset/checkexistingdataset?value=${name}`);
      if (exists) {
        commit('setNameError', this.vueApp.$nuxt.$i18n.global.t('admin.dataset.edit.name_validation'));
      }
    } catch (error) {
      this.$toast.error(this.$errorFromResponse('admin.dataset.edit.check_existing_dataset', error));
    }
  },

  /**
   * Fetches the EndpointServer list
   * @param { Object } ctx Vuex context
   */
  async getBlobEndpointServers({ commit }) {
    const endpointList = await getEndpointServersList();
    commit('setEndpointList', endpointList);
  },

  /**
   * Saves the dataset details
   * @param { Object } ctx Vuex context
   * @param { Object } datasetDetails Dataset details to be saved
   * @param { Boolean } isEdit Checks if the API call is for edit dataset component
   */
  async saveDataset({ commit, dispatch }, { datasetDetails, isEdit }) {
    let datasetValues = {
      ...datasetDetails,
      AutoUpload: datasetDetails.AutoUpload ? 1 : 0,
      AutoImportV3: datasetDetails.AutoImportV3 ? 1 : 0,
      AppendDataV3: datasetDetails.AppendDataV3 ? 1 : 0
    };

    commit('setIsSavingDataset', true);
    if (isEdit) {
      await dispatch('saveEditedDataset', datasetValues);
    } else {
      await dispatch('saveAddedDataset', datasetValues);
    }
  },

  /**
   * Saves the edited dataset details
   * @param { Object } ctx Vuex context
   * @param { Object } datasetDetails Dataset details to be saved
   */
  async saveEditedDataset({ commit }, datasetDetails) {
    try {
      await this.$axios.$put('/api/dataset?isEdit=true', datasetDetails);
      commit('dataset/setCurrentDatasetDetails', null, { root: true });
      this.$toast.success(this.vueApp.$nuxt.$i18n.global.t('admin.dataset.edit.dataset_edited'));
      navigateTo({
        name: 'admin-dataset-details-UUID-name',
        params: { UUID: datasetDetails.UUID, name: datasetDetails.Name }
      });
    } catch (error) {
      this.$toast.error(this.$errorFromResponse('admin.dataset.edit.something_went_wrong', error));
    } finally {
      commit('setIsSavingDataset', false);
    }
  },

  /**
   * Saves the added dataset details
   * @param { Object } ctx Vuex context
   * @param { Object } datasetDetails Dataset details to be saved
   */
  async saveAddedDataset({ commit }, datasetDetails) {
    try {
      const { UUID } = await this.$axios.$post('/api/dataset?isEdit=false', datasetDetails);
      commit('dataset/setCurrentDatasetDetails', null, { root: true });
      if (datasetDetails.FileStorageType === 'SFTP_Virtual_Machine') {
        navigateTo({
          name: 'admin-dataset-details-UUID-name',
          params: { UUID, name: datasetDetails.Name }
        });
      } else {
        this.$toast.success(this.vueApp.$nuxt.$i18n.global.t('admin.dataset.edit.dataset_added'));
        navigateTo({
          name: 'admin-dataset-details-UUID-name',
          params: { UUID, name: datasetDetails.Name }
        });
      }
    } catch (error) {
      this.$toast.error(this.$errorFromResponse('admin.dataset.edit.something_went_wrong', error));
    } finally {
      commit('setIsSavingDataset', false);
    }
  }
};
